import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const ideationRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/ideation",
  component: lazyRouteComponent(() => import("@l30/web-atlas/pages/ideation.page"), "IdeationPage"),
});
